import styles from "./School.module.css";

function School({ university }) {
  return (
    <div className={styles.university}>
      <div className={styles.content}>
        <h1>{university.degree}</h1>
        <h2>{university.school}</h2>
        <h3>{university.faculty}</h3>
      </div>
      <h2 className={styles.period}>{university.period}</h2>
    </div>
  );
}
export default School;
